/* eslint-disable no-param-reassign */
import flatMap from 'lodash/flatMap';

/**
 * @description 获取单个 url 的网址参数
 * @param {string} name 字段
 * @returns {(string | null)}
 */
export function getUrlKey(name) {
    return (
        decodeURIComponent(
            (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [
                ,
                '',
            ])[1].replace(/\+/g, '%20')
        ) || null
    );
}

/**
 * @description 获取 location.search 或 location.hash 中的值（支持同时查询多个）
 * @param {string} search [location.search | location.hash]
 * @param {Array<any>} keys 要查询的key
 * @returns {Record<string, (string | undefined)>}
 */
export const searchParams = (search, ...keys) => {
    search = search.replace(/#|\?/, '');
    const params = new URLSearchParams(search);

    return flatMap(keys).reduce((prev, key) => {
        prev[key] = params.get(key) || undefined;
        return prev;
    }, {});
};

export function removeSearchFromUrl(url) {
    const flag = url.includes('?');

    if (flag) {
        const index = url.indexOf('?');
        const newUrl = url.slice(0, index);
        return newUrl;
    }
    return url;
}

/**
 * @description 拼接 query
 * @param {Object} query 参数对象
 * @param {'?' | '#'} prefix query or hash，默认 ?
 * @param {'url' | 'component' | false } encode 启用 encodeURI 或 encodeURIComponent 编码，或 false 不进行编码
 * @return {string} 返回拼接后的 URL 网址参数(?params) 或 网址片段(#hash)
 */
export function queryConcat(query, prefix = '?', encode = 'component') {
    const encodeHandler = (function (method) {
        switch (method) {
            case 'url':
                return data => encodeURI(data);
            case 'component':
                return data => encodeURIComponent(data);
            default:
                return data => data;
        }
    })(encode);

    if (encode) {
        for (const key in query) {
            if (Object.hasOwnProperty.call(query, key)) {
                query[key] = encodeHandler(query[key]);
            }
        }
    }

    return Object.keys(query).reduce((prev, key, index) => {
        prev += `${index === 0 ? '' : '&'}${key}=${query[key]}`;
        return prev;
    }, prefix);
}
